import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import RightArrowIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { FILE_SIZE } from "../../common/constants";
import CButton from "../../components/CButton";
import CFormProvider from "../../components/CFormProvider";
import CFormTextField from "../../components/CFormTextField";
import CustomBreadcrumbs from "../../components/breadcrumbs/CustomBreadcrumbs";
import { fetchProfileDetails } from "../../slices/profileSlice";
import { postSupport } from "../../slices/settingSlice";

const Support = ({ profileImgUrl, ...props }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileDetails } = useSelector((state) => state.profile);
  const ProfileSchema = Yup.object().shape({
    firstName: Yup.string().required("Name is required"),
    lastName: Yup.string().required("Surname is required"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    description: Yup.string().required("Description is required"),
    lmaContactNo: Yup.string().required("LMA Contact is required"),
    employerName: Yup.string().required("Employer Name is required"),
    employeeNumber: Yup.string().required("Employee Number is required"),
    supportType: Yup.string().required("Support option is required"),
  });

  const [isOptionTechnical, setIsOptionTechnical] = useState(false);

  const supportOptions = [
    { value: "uif", label: "UIF" },
    { value: "mysalary", label: "MySalary" },
    { value: "hr", label: "HR" },
    { value: "technical", label: "Technical" },
    { value: "general", label: "General" },
  ];

  const supportOptionDetail = {
    uif: "For any UIF related queries, e.g. are you eligible for UIF payouts",
    mysalary: "For any queries related to your salary, e.g. not received, wrong amount, tax related issues, etc.",
    hr: "Any HR related queries, e.g. contract, who's your sponsor, where do I find a copy of my signed contract, etc.",
    technical: "Any technical queries related to the use of the Employee portal (My Workspace) e.g. video doesn't want to play, etc.",
    general: "All other queries.",
  };

  const [defaultValues, setDefaultValues] = useState({
    firstName: "",
    lastName: "",
    lmaContactNo: "",
    employerName: "",
    employeeNumber: "",
    email: "",
    description: "",
  });

  const methods = useForm({
    resolver: yupResolver(ProfileSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = methods;

  const docFile = watch("file");
  const selectedSupportOption = watch("supportType");

  useEffect(() => {
    setIsOptionTechnical(selectedSupportOption === "technical");
  }, [selectedSupportOption]);

  useEffect(() => {
    profileDetails !== null && setDefaultValues(profileDetails);
  }, [profileDetails]);

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues, methods]);

  const onDropDoc = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const fileType = file.type;
    //fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    if (
      file &&
      (fileType.startsWith("image/") ||
        fileType === "application/pdf" ||
        fileType.startsWith("video/")) &&
      file.size <= FILE_SIZE
    ) {
      setValue("file", file);
    } else {
      toast.error(
        "The uploaded file must be Image, PDF or Video and less than 10 MB"
      );
    }
  };

  console.log(errors, "ERRORS")
  const { getRootProps: getDocRootProps, getInputProps: getDocInputProps } =
    useDropzone({
      onDrop: onDropDoc,
      accept: ".pdf",
      multiple: false,
    });

  useEffect(() => {
    dispatch(fetchProfileDetails());
  }, [dispatch]);

  const onSubmit = (values) => {
    console.log(values, "VALUESS");
    const formDataPayload = new FormData();
    formDataPayload.append("firstName", values.firstName);
    formDataPayload.append("lastName", values.lastName);
    formDataPayload.append("employeeNumber", values.employeeNumber);
    formDataPayload.append("lmaContactNo", values.lmaContactNo);
    formDataPayload.append("email", values.email);
    formDataPayload.append("description", values.description);
    formDataPayload.append("supportType", values.supportType);
    if (values.file) formDataPayload.append("file", values.file);



    dispatch(postSupport(formDataPayload)).then((res) => {
      if (!res.error) {
        toast.success(res.payload.message);
        setTimeout(() => {
          navigate("/module");
        }, 2000);
      }
    });
  };


  const Placeholder = ({ children }) => {
    return <div>{children}</div>;
  };

  return (
    <>
      <div className="main-content">
        <Container fixed className="setting-container">
          <div className="breadcrumb-back">
            <CButton
              sx={{ border: " 0 !important" }}
              onClick={() => navigate("/module")}
            >
              <RightArrowIcon />
            </CButton>
            <CustomBreadcrumbs
              links={[
                {
                  name: "Dashboard",
                  href: "/module",
                },
                {
                  name: "Support",
                  href: "",
                },
              ]}
            />
          </div>
          <div className="setting-content support-content">
            <div className="card-box col-right">
              <h3>Support</h3>
              <div className="edit-profile-form">
                <CFormProvider methods={methods} onSubmit={handleSubmit()}>
                  <CFormTextField
                    label="First Name"
                    name="firstName"
                    // placeholder="John"
                    // value="John"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  <CFormTextField
                    label="Last Name"
                    name="lastName"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  <CFormTextField
                    label="Employee Number"
                    name="employeeNumber"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  <CFormTextField
                    label="LMA Contact Number"
                    name="lmaContactNo"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />

                  {!isOptionTechnical && (
                    <CFormTextField
                      label="Email Address"
                      name="email"
                      InputLabelProps={{ shrink: true }}
                      // sx={{ width: "100% !important" }}
                    />
                  )}
                  <FormControl
                    fullWidth
                    className="CSelect"
                    error={!!errors.supportType}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <InputLabel id="demo-simple-select-label">
                        Support Options
                      </InputLabel>
                      <Tooltip
                        title={supportOptionDetail[selectedSupportOption]}
                        arrow
                        placement="top"
                      >
                        <Button
                          size="large"
                          sx={{
                            minWidth: "24px",
                            padding: "0",
                            color: "black",
                          }}
                        >
                          ?
                        </Button>
                      </Tooltip>
                    </Box>

                    <Controller
                      name="supportType"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          labelId="support-option-label"
                          displayEmpty
                          renderValue={
                            field.value
                              ? undefined
                              : () => <Placeholder>Select Support</Placeholder>
                          }
                        >
                          {supportOptions.map((data) => (
                            <MenuItem key={data.value} value={data.value}>
                              {data.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />

                    {errors.supportType && (
                      <FormHelperText>
                        {errors.supportType.message}
                      </FormHelperText>
                    )}
                  </FormControl>

                  {!isOptionTechnical ? (
                    <>
                      <CFormTextField
                        label="Description"
                        name="description"
                        multiline
                        rows={4}
                        maxRows={4}
                        sx={{
                          mb: 1,
                          width: "100% !important",
                          marginBottom: "0 !important",
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                      <div className="CTextField support-file">
                        <label>Upload</label>
                        <Box {...getDocRootProps()} className="upload-input">
                          <input {...getDocInputProps()} />
                          <Typography>
                            {docFile
                              ? docFile.name
                              : "Drag and drop a file here, or click to select one"}
                          </Typography>
                          {docFile && (
                            <IconButton
                              onClick={(e) => {
                                setValue("file", null);
                                e.stopPropagation();
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          )}
                        </Box>
                      </div>
                      <div className="submit-btn">
                        <CButton
                          onClick={handleSubmit(onSubmit)}
                          className="btn-primary"
                        >
                          Submit
                        </CButton>
                      </div>
                    </>
                  ) : (
                    <div className="CTextField support-file">
                        <div
                        style={{
                          display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                          paddingTop: "20px",
                            textAlign: "left",
                            lineHeight: "1.5",
                        }}
                      >
                          <p>Please list your query via the LMA SIM Customer Care WhatsApp number, <strong>063 901 0000</strong>.</p>
                          <br />
                          <p><strong>Step 1:</strong> Open LMA SIM Customer Care (0639010000) on WhatsApp.</p>
                          <br />
                          <p><strong>Step 2:</strong> Send the following message; Identify yourself (Name, Surname, LMA Connect number, ID no.) and then give a brief description of the problem you are experiencing.</p>
                          <br />
                          <p><strong>Step 3:</strong> Send the message.</p>
                          <br />
                          <p><strong>Step 4:</strong> LMA SIM Customer Care will respond within WhatsApp on the same number.</p>
                          <br />
                          <p><strong>Step 5:</strong> Follow instructions and respond accordingly until issue is resolved.</p>
                        </div>
                    </div>
                  )}
                </CFormProvider>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Support;